import React from 'react';

const gbp = (n) => `£${Number(n || 0).toFixed(2)}`;

export function PayoutEquation({ earnings }) {
  const gross = earnings.total_gross_revenue;
  const fees = earnings.total_platform_fees ?? (earnings.total_commission_paid + earnings.total_processing_fees);
  return (
    <div className="mt-4 pt-4 border-t border-[#E6E4DD]" data-testid="payout-equation">
      <div className="grid grid-cols-[1fr_auto_1fr_auto_1fr] items-center gap-2 sm:gap-4 text-center">
        <div>
          <p className="font-heading text-xl sm:text-2xl text-[#1A1A1A]" data-testid="payout-total-earned">{gbp(gross)}</p>
          <p className="text-xs text-stone-500 mt-0.5">Total earned</p>
        </div>
        <span className="text-stone-400 text-lg" aria-hidden>-</span>
        <div>
          <p className="font-heading text-xl sm:text-2xl text-red-500" data-testid="payout-platform-fee">{gbp(fees)}</p>
          <p className="text-xs text-stone-500 mt-0.5">Platform fee</p>
        </div>
        <span className="text-stone-400 text-lg" aria-hidden>=</span>
        <div>
          <p className="font-heading text-xl sm:text-2xl text-emerald-600" data-testid="payout-total-payout">{gbp(earnings.total_earned)}</p>
          <p className="text-xs text-stone-500 mt-0.5">Total payout</p>
        </div>
      </div>
      <p className="text-[11px] text-stone-400 text-center mt-3">
        Excludes refunded bookings{earnings.total_refunded > 0 ? ` (${gbp(earnings.total_refunded)})` : ''}. Clients never pay a booking fee.
      </p>
    </div>
  );
}

export function BetaFeeTiles({ earnings }) {
  const pct = earnings.beta_fee_percent;
  const proc = earnings.tier_config;
  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-4" data-testid="beta-fee-tiles">
      <div className="p-4 bg-stone-50 rounded-lg text-center">
        <p className="text-2xl font-semibold text-[#1A1A1A]" data-testid="effective-commission-rate">{pct}%</p>
        <p className="text-xs text-stone-500 mt-1">New marketplace clients, Stripe costs included</p>
      </div>
      <div className="p-4 bg-stone-50 rounded-lg text-center">
        <p className="text-2xl font-semibold text-[#1A1A1A]">0%</p>
        <p className="text-xs text-stone-500 mt-1">
          Repeat clients and your own link (Stripe {(proc.processing_rate * 100).toFixed(2)}% + {Math.round(proc.processing_fixed * 100)}p)
        </p>
      </div>
      <div className="p-4 bg-stone-50 rounded-lg text-center">
        <p className="text-2xl font-semibold text-[#1A1A1A]">£0</p>
        <p className="text-xs text-stone-500 mt-1">Booking fee for clients</p>
      </div>
      <p className="sm:col-span-3 text-xs text-stone-600 bg-[#F9F6F0] rounded-lg p-3" data-testid="beta-fee-example">
        <strong>Example:</strong> a new client pays £100, you receive £{(100 - pct).toFixed(2)} and £{pct.toFixed(2)} covers Stripe and the platform.
      </p>
    </div>
  );
}
